"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllContractsForRange = getAllContractsForRange;
exports.getContractForRange = getContractForRange;
exports.getContractForDate = getContractForDate;
function getAllContractsForRange(contracts, { from, to }) {
    // TODO: this mutates the original array, which is not ideal.
    contracts.sort((a, b) => (a.start < b.start ? -1 : 1));
    return contracts.filter((c) => {
        return c.start < to && (!c.end || c.end > from);
    });
}
function getContractForRange(contracts, range) {
    return getAllContractsForRange(contracts || [], range)[0] || null;
}
function getContractForDate(contracts, date) {
    return contracts.find((c) => c.start <= date && (!c.end || c.end > date));
}
//# sourceMappingURL=contract.util.js.map